import React from 'react'
import Link from 'next/link'
import { ArrowUpRight, CalendarClock, ClipboardCheck, CreditCard } from 'lucide-react'

const TOOLS = [
  {
    id: 'eligibility-assessment',
    title: 'Immigration Assessment',
    description: 'Take the first step — discover your visa options based on your situation.',
    href: '/eligibility',
    icon: ClipboardCheck,
  },
  {
    id: 'h1b-maxout-calculator',
    title: 'H-1B Max-Out Calculator',
    description:
      'Estimate your H-1B six-year limit and see when to start PERM and I-140 planning.',
    href: '/h1b-maxout-calculator',
    icon: CalendarClock,
  },
  {
    id: 'pay-bill',
    title: 'Pay My Bill',
    description: 'Securely pay your legal fees online through our payment portal.',
    href: '/pay-my-bill',
    icon: CreditCard,
  },
]

export function ToolsCalculators() {
  return (
    <section className="pt-4! md:pt-16 pb-8 md:pb-12 px-6 md:px-12 lg:px-16">
      <div className="max-w-380 mx-auto">
        <h2 className="text-2xl md:text-3xl font-medium text-gray-900 mb-6 md:mb-8">Tools</h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {TOOLS.map((tool) => {
            const isExternal = tool.href.startsWith('http')
            const Icon = tool.icon
            const Component = isExternal ? 'a' : Link
            const extraProps = isExternal ? { target: '_blank', rel: 'noopener noreferrer' } : {}

            return (
              <Component
                key={tool.id}
                href={tool.href}
                {...extraProps}
                className="group p-6 md:p-8 bg-white hover:bg-gray-50 rounded-xl transition-all border border-gray-200 hover:border-gray-300 hover:shadow-md"
              >
                <div className="flex flex-col h-full">
                  <div className="w-12 h-12 rounded-xl bg-brand-blue/10 flex items-center justify-center mb-4">
                    <Icon className="w-6 h-6 text-brand-blue" />
                  </div>
                  <h3 className="text-lg md:text-xl font-medium text-gray-900 mb-2 group-hover:text-brand-blue transition-colors">
                    {tool.title}
                  </h3>
                  <p className="text-sm md:text-base text-gray-600 mb-4 flex-1">
                    {tool.description}
                  </p>
                  <div className="flex items-center text-brand-blue">
                    <ArrowUpRight className="w-5 h-5 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
                  </div>
                </div>
              </Component>
            )
          })}
        </div>
      </div>
    </section>
  )
}
